import React from 'react';
import { useObserver } from 'mobx-react-lite';
import utilsService from '../../../../../servises/utils.service';
import styled from 'styled-components';
import { EuiIcon } from '@elastic/eui';
import serverStore from "../../../../../stores/server.store";

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 0;
`;

const StatGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;
`;

const StatItem = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  
  .label-group {
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(255, 255, 255, 0.45);
    font-weight: 500;
    
    .icon {
      opacity: 0.6;
    }
  }
  
  .value {
    color: #fff;
    font-weight: 700;
    font-family: Consolas, monospace;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const ServerProcessesWidget = ({ server }) => {
    return useObserver(() => {
        const count = utilsService.getFromMetrics(server, 'processes', '-');
        const processesList = serverStore.serverProcesses?.processes_list || [];
        
        let topCpu = '-';
        let topCpuVal = 0;
        let rootCount = 0;
        
        processesList.forEach(p => {
            const cpuVal = parseFloat(p.cpu) || 0;
            if (cpuVal > topCpuVal) {
                topCpuVal = cpuVal;
                topCpu = `${p.process_name} (${cpuVal}%)`;
            }
            if (p.user === 'root') {
                rootCount++;
            }
        });

        const userCount = Math.max(0, processesList.length - rootCount);

        return (
            <CardWrapper>
                <StatGrid>
                    {/* Total Count */}
                    <StatItem>
                        <div className="label-group">
                            <EuiIcon type="createPopulationJob" size="s" className="icon" />
                            <span>Total Processes</span>
                        </div>
                        <span className="value">{ count }</span>
                    </StatItem>
                    
                    {/* Top CPU Consumer */}
                    <StatItem>
                        <div className="label-group">
                            <EuiIcon type="compute" size="s" className="icon" />
                            <span>Top CPU Consumer</span>
                        </div>
                        <span className="value" style={ topCpuVal > 50 ? { color: 'rgb(248, 107, 99)' } : {} } title={ topCpu }>
                            { topCpu }
                        </span>
                    </StatItem>

                    {/* System vs User Tasks */}
                    <StatItem>
                        <div className="label-group">
                            <EuiIcon type="users" size="s" className="icon" />
                            <span>System vs User</span>
                        </div>
                        <span className="value">
                            { rootCount } / { userCount }
                        </span>
                    </StatItem>
                </StatGrid>
            </CardWrapper>
        );
    });
};

export default ServerProcessesWidget;
